/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientOnboardingModel } from '../../models/patient-onboarding-model';

export interface PatientOnboardingIdGet$Params {
  id: string;
}

export function patientOnboardingIdGet(http: HttpClient, rootUrl: string, params: PatientOnboardingIdGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<PatientOnboardingModel>> {
  const rb = new RequestBuilder(rootUrl, patientOnboardingIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<PatientOnboardingModel>;
    })
  );
}

patientOnboardingIdGet.PATH = '/PatientOnboarding/{id}';
